import { Link } from 'react-router';
import { Plus } from 'lucide-react';

import { Main } from 'src/components/Layout';
import { usePageMeta } from 'src/hooks';
import { ApplicationsListContainer } from 'src/containers/Applications/List';
import { PendingVendorRequestsBanner } from 'src/containers/VendorRequests';
import { Button } from '@/components/ui/button';

import UnclaimedBanner from './ui/UnclaimedBanner';

const ApplicationsPage = () => {
  usePageMeta('Applications');

  return (
    <Main
      title="Applications"
      mainContentClassName="overflow-y-scroll"
      headerActions={
        <Button asChild size="sm">
          <Link to="/applications/new">
            <Plus />
            Create app
          </Link>
        </Button>
      }
    >
      <div className="container mx-auto space-y-6">
        <UnclaimedBanner />
        <PendingVendorRequestsBanner />
        <ApplicationsListContainer />
      </div>
    </Main>
  );
};

export default ApplicationsPage;
